export default "__VITE_PUBLIC_ASSET__00342364__"